import { RestoreableModel, ResourceFactory } from '../services/';

class Project extends RestoreableModel {
  public name:        string = '';
  public campaigns_count: number = 0;
  public reference:   string = '';
  public agency:      string = '';
  public manager:     string = '';
  public contact:     string = '';
  public description: string = '';
}

const ProjectFactory = ResourceFactory.create<Project>(Project, 'project');

export { Project, ProjectFactory };
